<div class="container account-result-page">
  <div class="row justify-content-center align-items-start">
    <div *ngIf="isLoading" class="text-center">
      <app-loading-spinner></app-loading-spinner>
    </div>
    <div
      *ngIf="activationSuccess"
      class="card-footer alert alert-success col-12 col-xs-9 col-lg-8"
    >
      {{ 'YOUR_EMAIL_ADDRESS_HAS_BEEN_VERIFIED_CONTINUE_TO_YOUR_ACCOUNT' | translate }}<a
        [routerLink]="['/', tenantSubdomain, 'login']"
        >{{ 'RESET_SUCCESSFUL_LINK' | translate }}</a
      >
    </div>
    <div
      *ngIf="activationFailure"
      class="card-footer alert alert-danger col-12 col-xs-9 col-lg-8"
    >
      {{ 'THIS_EMAIL_VERIFICATION_LINK_IS_INVALID_OR_HAS_EXPIRED_YOUR_ACCOUNT_AND_' | translate }}<a
        [routerLink]="['/', tenantSubdomain, 'email-access']"
        >{{ 'RESET_SUCCESSFUL_LINK' | translate }}</a
      >.
    </div>
  </div>
</div>
